import React from "react";

import { Dropdown, Icon, Label, Popup } from "semantic-ui-react";
import DropDownItemFolder from "./DropDownItemFolder";
import { getTimeBeforeResult, getTimeBeforeSamplingAnalysis, getTimeBeforeNextTube } from "utils/folder";

const styles = {
	labelnotification: {
		marginLeft: "-21px",
		marginBottom: "-21px",
		zIndex: "5",
		fontSize: "9px",
	},
};
const getPortionWaitingFolders = (foldersWaiting) => {
	const folders = foldersWaiting.result
		.filter((p) => p.status !== "CANCELED")
		.map((f) => {
			return { code: f.code, type: "result", done: getTimeBeforeResult(f) <= 0 };
		})
		.concat(
			foldersWaiting.patient
				.filter((p) => p.status !== "CANCELED")
				.map((f) => {
					return { code: f.code, type: "patient", done: getTimeBeforeSamplingAnalysis(f) <= 0 };
				})
		)
		.concat(
			foldersWaiting.tube
				.filter((p) => p.status !== "CANCELED")
				.map((f) => {
					return { code: f.code, type: "tube", done: getTimeBeforeNextTube(f) <= 0 };
				})
		);
	return (
		<Label circular color="red" style={styles.labelnotification}>
			<span>{folders.filter((f) => f.done).length}</span> / <span>{folders.length}</span>
		</Label>
	);
};

const WaitingFoldersDropDown = ({ foldersWaiting, focusFolderManager, goToResult, goToTubes }) => {
	if (
		(foldersWaiting.result && foldersWaiting.result.length > 0) ||
		(foldersWaiting.patient && foldersWaiting.patient.length > 0) ||
		(foldersWaiting.tube && foldersWaiting.tube.length > 0)
	)
		return (
			<Popup
				content="Dossiers en attente"
				position="bottom center"
				trigger={
					<Dropdown
						icon={
							<>
								<Icon name="wait" style={{ fontSize: "36px" }} />
								{getPortionWaitingFolders(foldersWaiting)}
							</>
						}
						item
					>
						<Dropdown.Menu style={{ maxHeight: "500px", overflow: "auto" }}>
							<Dropdown.Header icon="pin" content="Dossiers en attente" />
							{foldersWaiting.result
								.filter((p) => p.status !== "CANCELED")
								.map((f) => (
									<DropDownItemFolder
										key={`ddifw-${f.id}`}
										folder={f}
										folderHelp={false}
										fastresult={true}
										focusFolderManager={focusFolderManager}
										goToResult={goToResult}
									/>
								))}
							{foldersWaiting.patient
								.filter((p) => p.status !== "CANCELED")
								.map((f) => (
									<DropDownItemFolder
										key={`ddifpat-${f.id}`}
										folder={f}
										folderHelp={false}
										fastresult={false}
										beforeAnalysis={true}
										sampling={false}
										focusFolderManager={focusFolderManager}
										goToTubes={goToTubes}
									/>
								))}
							{foldersWaiting.tube
								.filter((p) => p.status !== "CANCELED")
								.map((f) => (
									<DropDownItemFolder
										key={`ddiftube-${f.id}`}
										folder={f}
										folderHelp={false}
										fastresult={false}
										sampling={true}
										beforeAnalysis={false}
										focusFolderManager={focusFolderManager}
										goToTubes={goToTubes}
									/>
								))}
						</Dropdown.Menu>
					</Dropdown>
				}
			/>
		);
	return null;
};

export default WaitingFoldersDropDown;
